// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__1c8I6","raw":"Checkbox_raw__MMwF1","checkboxLabel":"Checkbox_checkboxLabel__vWupm"};